import Vue from "vue";
import Vuex from "vuex";
import { axiosFactory, errorHandler } from "@/configs/axios";
import auth from "./modules/auth";
import global from "./modules/global";
import dashboard from "./modules/dashboard";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {
    markerList(context) {
      return axiosFactory()
        .auth.get("customer/v1/car-live-state/")
        .then((res) => {
          return res.data;
        })
        .catch((error) => {
          return false;
        });
    },
  },

  modules: {
    auth,
    global,
    dashboard,
  },
});
